angular.module('unica_event.event_services')

.factory('EventSiteService', function ($http, getBaseApiURL) {

	var eventSiteService = {};

	eventSiteService.updateSite = function (id, eventData) {

		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/update-site/' + id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSiteService.deleteSiteCover = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/remove-site-cover/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSiteService.deleteSiteLogo = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/remove-site-logo/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSiteService.deleteFeaturedImage = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/remove-featured-image/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSiteService.deleteFeaturedImageMobile = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/remove-featured-image-mobile/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSiteService.deleteEventProgram = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/remove-program/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	eventSiteService.checkSitePreview = function(id) {
		return $http({
			method: 'post',
			url: getBaseApiURL + '/event/check-site-preview/' + id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	return eventSiteService;
});